





























import { Vue, Component, Prop } from 'vue-property-decorator';
import { BrowserHelper } from '@signing-page/helpers/browser.helper';
import type { ITheme } from '@signing-page/api/theme/types/theme';
import { BrandingHelper } from '@signing-page/helpers/branding.helper';

@Component
export default class ChatFab extends Vue {
  @Prop() open!: boolean;
  @Prop() newCommentsCount!: number;
  @Prop() theme?: ITheme;

  public handleClick(): void {
    this.$emit('click');
  }

  get hasNewComments(): boolean {
    return this.newCommentsCount > 0;
  }

  public get isBrowserIE(): boolean {
    return BrowserHelper.isIE(navigator);
  }

  get hasTheme(): boolean {
    return !!this.theme && !!this.theme.accentColor;
  }

  get chatFabStyle() {
    if (this.hasTheme) {
      return {
        '--chat-background-color': BrandingHelper.getBackgroundColor(
          this.theme.accentColor,
          false,
          false
        ),
        '--chat-background-color--hover': BrandingHelper.getBackgroundColorHover(
          this.theme.accentColor,
          false,
          false
        ),
        '--icon-color': BrandingHelper.getTextColor(this.theme.accentColor, false, false),
      };
    }
    return {};
  }
}
